import { Injectable, signal } from '@angular/core';
import { defaultSeriesTableConfig, resolveSeriesTableConfig, SeriesTableConfig } from '../series-dashboard/series-table-config';

@Injectable({ providedIn: 'root' })
export class SeriesTableConfigService {
  private readonly _config = signal<SeriesTableConfig>(defaultSeriesTableConfig);
  readonly config = this._config.asReadonly();

  setFromAssetClasses(assetClasses: string[] | undefined): void {
    this._config.set(resolveSeriesTableConfig(assetClasses));
  }
}
